const template = require('./success-criteria.tpl').default;

module.export = DomClass(template, function SuccessCriteria() {
	
});

